import clsx from 'clsx';
import React from 'react';

import { getProjectPageUrl } from '@/src/components/project/projectDetails';

type AccountLinkProps = {
  projectName: string;
  projectId: string;
};

const AccountLink = ({ projectId, projectName }: AccountLinkProps) => {
  return (
    <a
      href={getProjectPageUrl(projectId)}
      className={clsx(
        'tw-h-[20px]tw-leading-[14px] tw-ml-3 tw-leading-[20px] tw-text-cfo-blue-600 tw-underline'
      )}
    >
      {projectName}
    </a>
  );
};

export default AccountLink;
